import { useReportingContext } from 'modules/iterableGoals/contexts';
import { PerformantCampaignVariant } from 'modules/iterableGoals/types';
import { localizeCurrencyValue } from 'utils/i18nHelpers';
import { compactNumber } from 'utils/numberHelpers';
import { ContributionCount, ContributionWrapper, TooltipText } from './Styled';

type ContributionProps = {
  campaignVariant: PerformantCampaignVariant;
  contributions: number;
  revenue: number;
};

export const Contributions = ({
  campaignVariant,
  contributions,
  revenue = 0,
}: ContributionProps) => {
  const { isRevenue, getReportingTranslation } = useReportingContext();
  const reportedValue = isRevenue ? revenue : contributions;

  return (
    <ContributionWrapper>
      <ContributionCount campaignVariant={campaignVariant}>
        {isRevenue
          ? localizeCurrencyValue(reportedValue, { notation: 'compact' })
          : compactNumber(reportedValue)}
      </ContributionCount>
      <TooltipText>{getReportingTranslation('labels.performantCampaigns.infoText')}</TooltipText>
    </ContributionWrapper>
  );
};
